import { select, Selection } from 'd3';

export default class ToolTip {
  parentId: string;
  element: Selection<HTMLDivElement, unknown, HTMLElement, undefined>;

  constructor(params?: { parentId: string }) {
    if (params?.parentId) this.parentId = params.parentId;
    this.bindToParent();
  }

  bindToParent() {
    this.element = select(this.parentId)
      .append('div')
      .style('position', 'absolute')
      .style('opacity', 0)
      .attr('class', 'tooltip')
      .style('background-color', 'white')
      //   .style('border', 'solid')
      .style('box-shadow', 'rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px')
      //   .style('border-width', '2px')
      .style('border-radius', '5px')
      .style('padding', '5px');
  }

  show() {
    this.element.style('opacity', 1);
  }

  hide() {
    this.element.style('opacity', 0);
  }

  updateLoc(x, y) {
    console.log(x, y);
    this.element.html('tooltip').style('left', `${x}px`).style('top', `${y}px`);
  }
}
